import Layout from '@/layout'

const villageRouter = {
  path: '/register',
  component: Layout,
  children: [
    {
      path: '/order',
      name: 'order',
      meta: {
        title: '订单管理',
      },
      component: () => import('@/views/shop/order.vue'),
    },
    {
      path: '/category',
      name: 'category',
      meta: {
        title: '商品分类',
      },
      component: () => import('@/views/shop/category.vue'),
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      meta: {
        title: '订单评价',
      },
      component: () => import('@/views/shop/evaluate.vue'),
    },
  ],
}

export default villageRouter
